export var IdAssetBundleExternalBarn;
(function (IdAssetBundleExternalBarn) {
    IdAssetBundleExternalBarn["ExternalBarn_0"] = "ExternalBarn_0";
    IdAssetBundleExternalBarn["ExternalBarn_1"] = "ExternalBarn_1";
    IdAssetBundleExternalBarn["ExternalBarn_2"] = "ExternalBarn_2";
    IdAssetBundleExternalBarn["ExternalBarn_3"] = "ExternalBarn_3";
    IdAssetBundleExternalBarn["ExternalBarn_4"] = "ExternalBarn_4";
    IdAssetBundleExternalBarn["ExternalBarn_5"] = "ExternalBarn_5";
    IdAssetBundleExternalBarn["ExternalBarn_6"] = "ExternalBarn_6";
    IdAssetBundleExternalBarn["ExternalBarn_7"] = "ExternalBarn_7";
    IdAssetBundleExternalBarn["ExternalBarn_8"] = "ExternalBarn_8";
    IdAssetBundleExternalBarn["ExternalBarn_9"] = "ExternalBarn_9";
    IdAssetBundleExternalBarn["ExternalBarn_10"] = "ExternalBarn_10";
    IdAssetBundleExternalBarn["ExternalBarn_11"] = "ExternalBarn_11";
    IdAssetBundleExternalBarn["ExternalBarn_12"] = "ExternalBarn_12";
    IdAssetBundleExternalBarn["ExternalBarn_13"] = "ExternalBarn_13";
    IdAssetBundleExternalBarn["ExternalBarn_14"] = "ExternalBarn_14";
    IdAssetBundleExternalBarn["ExternalBarn_15"] = "ExternalBarn_15";
    IdAssetBundleExternalBarn["ExternalBarn_16"] = "ExternalBarn_16";
    IdAssetBundleExternalBarn["ExternalBarn_17"] = "ExternalBarn_17";
})(IdAssetBundleExternalBarn || (IdAssetBundleExternalBarn = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleExternalBarn.ts
// module id = 2137
// module chunks = 3